import FacebookSmall from "../icons/FacebookSmall";
import InstagramSmall from "../icons/InstagramSmall";
import TwitterSmall from "../icons/TwitterSmall";
import TiktokSmall from "../icons/TiktokSmall";

export const socialMediaData = [{ id: 1, name: "Facebook", icon: <FacebookSmall/> },    
  { id: 2, name: "Instagram", icon: <InstagramSmall/> },
  { id: 3, name: "Twitter", icon: <TwitterSmall/> },
  { id: 4, name: "TikTok", icon: <TiktokSmall/> }
]